import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress
} from '@mui/material';
import { grey } from '@mui/material/colors';
import { getUserById } from "../../services/userService.js";
import blackLogo from "../../assets/images/blackLogo.svg";

function LinkedInCompleteProfile() {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        email: '',
        company: ''
    });

    useEffect(() => {
        const fetchUserData = async () => {
            const urlParams = new URLSearchParams(location.search);
            const userInfo = urlParams.get('userInfo');
            const success = urlParams.get('success');

            if (success === 'true') {
                try {
                    const userData = await getUserById(userInfo);
                    localStorage.setItem('userInfo', JSON.stringify(userData));
                    navigate('/dashboard');
            } catch (error) {
                console.error('Error parsing LinkedIn data:', error);
                setError('Invalid LinkedIn data received');
            }
        } else {
            setError('No LinkedIn data received');
        }
        };
        fetchUserData();
    }, [location, navigate]);

  return (
    <Box sx={{ minHeight: "100vh", width: "100vw", display: "flex", flexDirection: { xs: "column", md: "row" } }}>
      {/* Left Side - Form */}
      <Box display="flex" flexDirection="column" sx={{px: 4, backgroundColor: grey[100], minHeight: "100vh", width: {xs: "100vw", md: "50vw"}}}>
        <Box sx={{pt: 4, pb: 2, display: 'flex', justifyContent: { xs: 'center', md: 'center' }}}>
          <img src={blackLogo} alt="getLista" style={{ height: 40 }} />
        </Box>
        
        <Box flexGrow={1} margin={{ xs: 0, sm: 1, md: 2 }} display="flex" alignItems="center" justifyContent="center">
          <Paper elevation={3} sx={{p: { xs: 2, sm: 5 }, width: "100%", maxWidth: 500, borderRadius: 4, background: "#ffffff"}}>
            
            {loading && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1000,
                  borderRadius: 4
                }}
              >
                <CircularProgress />
              </Box>
            )}

            {error && (
              <Alert severity="error" sx={{ mt: 2, mb: 2, width: '100%' }}>
                {error}
              </Alert>
            )}

            <Typography variant="h5" sx={{ fontWeight: 800, mb: 2, textAlign: "center", color: "black"}}>
              Complete Your Profile
            </Typography>
            <Typography variant="body2" sx={{ color: "black", mb: 3, textAlign: "center" }}>
              Please provide your email address to complete your LinkedIn registration.
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              
              
            </Box>
          </Paper>
        </Box>
      </Box>

      {/* Right Side - Image */}
      <Box sx={{flex: 1, display: { xs: "none", md: "flex" }, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", alignItems: 'center', justifyContent: 'center'}}>
        <Box sx={{ textAlign: 'center', color: 'white', p: 4 }}>
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 700 }}>
            Welcome to Getlista!
          </Typography>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Your LinkedIn profile has been connected successfully.
          </Typography>
          <Typography variant="body1">
            Just one more step to complete your registration and start using our platform.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default LinkedInCompleteProfile; 